export default __webpack_public_path__ + "43f25e1a004525c69ae090362b20412c.png";